import { MainNavigation, MainNavigationCollapsibleItem, MainNavigationItemRouterLink } from "@comet/admin";
import { useUser } from "@vivid/react-oidc-client";

import { filterPagesByRoleRecursive } from "./pages/filter";
import { type PageInterface } from "./pages/page.interface";

const MenuItem = (page: PageInterface) => {
    if (!page.menuProps) return null;

    if (page.childPages !== undefined) {
        return (
            <MainNavigationCollapsibleItem
                primary={page.menuProps.text}
                icon={page.menuProps.icon}
                openByDefault={page.menuProps.isOpen !== undefined ? page.menuProps.isOpen : false}
            >
                {page.childPages.map((child) => (
                    <MenuItem key={child.routeProps.path} {...child} />
                ))}
            </MainNavigationCollapsibleItem>
        );
    } else {
        const { path } = page.routeProps;
        return <MainNavigationItemRouterLink primary={page.menuProps.text} icon={page.menuProps.icon} to={path} />;
    }
};

export function MasterMenu() {
    const user = useUser();

    return (
        <MainNavigation>
            {filterPagesByRoleRecursive(user).map((page) => (
                <MenuItem key={page.routeProps.path} {...page} />
            ))}
        </MainNavigation>
    );
}
